import type { EnTranslation } from './en';

/** Bahasa Melayu — same shape as `en`. */
export const ms: EnTranslation = {
  header: {
    brandAlt: 'Avatar',
    title: 'Sembang dengan {{name}}',
    subtitle: 'Tanya, teroka, atau dapatkan bantuan serta-merta',
    reset: 'Set semula perbualan',
  },
  chat: {
    typing: 'Avatar sedang menaip…',
    errorFallback:
      'Maaf tentang ini. Saya tidak dapat membantu permintaan anda buat masa ini kerana isu sementara di pihak kami. Sila cuba lagi sebentar lagi.',
    networkError:
      'Ralat rangkaian. Sila semak sambungan anda dan cuba lagi.',
    widgetDisabled:
      'Sembang ini tidak lagi tersedia. Mesej baharu tidak dapat dihantar buat masa ini.',
    rateLimited: 'Anda menghantar mesej terlalu cepat. Sila tunggu sebentar dan cuba lagi.',
    originNotAllowlisted:
      'Sembang ini belum tersedia di laman web ini. Sila hubungi pemilik laman web.',
    bundleNotAllowlisted:
      'Sembang ini belum tersedia dalam aplikasi ini. Sila hubungi penyedia aplikasi.',
    identifyDisabled: 'Pengesahan identiti dinyahaktifkan untuk avatar ini.',
    identifyRequired:
      'Kami tidak dapat mengesahkan log masuk anda. Sila log masuk, kemudian buka sembang semula.',
    retry: 'Cuba lagi',
    streamingPlaceholder: '…',
    newConversationStarted: 'Perbualan baru dimulakan',
    yesterday: 'Semalam',
  },
  input: {
    placeholder: 'Tanya apa sahaja...',
    ariaLabel: 'Mesej Avatar',
    send: 'Hantar mesej',
    attach: 'Lampirkan fail',
    attachments: 'Fail dilampirkan',
    removeAttachment: 'Buang fail {{index}}',
    retryUpload: 'Cuba muat naik {{name}} sekali lagi',
    uploading: 'Memuat naik {{percent}}%',
    uploadFailed: 'Muat naik gagal. Ketik untuk cuba lagi.',
    pickPhotos: 'Galeri Foto',
    pickFiles: 'Pilih Fail',
    pickCancel: 'Batal',
    poweredBy: 'Dikuasakan oleh Avatar.inc',
  },
  popular: {
    ariaLabel: 'Soalan dicadangkan',
  },
  attachment: {
    typeNotAllowed:
      '{{name}} tidak boleh dilampirkan. Hanya fail JPG, PNG, WEBP dan PDF dibenarkan.',
    tooLarge: '{{name}} melebihi 10 MB dan tidak boleh dilampirkan.',
    limit: 'Anda boleh melampirkan sehingga 5 fail bagi setiap mesej.',
    rateLimited: 'Terlalu banyak muat naik. Sila tunggu sebentar dan cuba lagi.',
    disabled: 'Muat naik fail dimatikan untuk sembang ini.',
    uploadFailed: '{{name}} tidak dapat dimuat naik. Ketik untuk cuba lagi.',
    sendInvalid:
      'Fail anda tidak dapat dihantar. Sila lampirkan semula.',
    sendTypeNotAllowed:
      'Salah satu fail anda bukan JPG, PNG, WEBP atau PDF yang sah, atau imej terlalu besar. Sila buang dan cuba lagi.',
    sendTooLarge: 'Salah satu fail anda melebihi 10 MB. Sila buang dan cuba lagi.',
    unavailable: 'Fail tidak dapat dihantar buat masa ini. Sila cuba lagi sebentar lagi.',
    sessionExpired:
      'Sesi sembang anda tamat sebelum dihantar, jadi fail telah luput. Sila lampirkan semula.',
  },
  mobile: {
    subtitle: 'Pembantu AI anda untuk {{name}}.',
    hello: 'Helo, saya {{name}}',
    heroBody:
      'Saya boleh bantu anda teroka, cipta, dan manfaatkan {{name}} dengan sepenuhnya.',
    heroHint: 'Pilih soalan di bawah atau taip mesej.',
    heroHintVoice:
      'Pilih soalan di bawah atau ketik mikrofon untuk bertanya secara suara.',
    popularHeading: 'Soalan Popular',
    placeholder: 'Tanya {{name}}...',
    back: 'Tutup',
    mic: 'Input suara',
  },
  doc: {
    title: 'Widget Avatar',
  },
};
